import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValues10, KeyValues5, KeyValueSet, LocalService, PageKey, Wrappers10 } from 'src/service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';

@Component({
  selector: 'app-b2b-licenses',
  templateUrl: './b2b-licenses.component.html',
  styleUrl: './b2b-licenses.component.scss'
})
export class B2bLicensesComponent {
  InteractionType = InteractionType;
  lstSectionConfigKeys: string[] = ["common", "table", "plan_purchase"];
  ctryCode: string = ''; b2bId: string = ''; interactionType = 0; maxBodyHeight = 0;

  tabs: KeyValueSet[] = []; selectedTabKey: string = ''; planTypes: KeyValueSet[] = [];

  b2bLicenseSummary: KeyValues10[] = []; wrapper: Wrappers10;

  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private planPurchaseService: PlanPurchaseService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.b2bId = routeParams.b2bId ?? '';
      this.ctryCode = routeParams.ctryCode;

      this.configurationManagementService.ensurePageActions(PageKey.B2bLicence, this.b2bId);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, this.b2bId);

      this.onInitiate();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoadTabs();
    this.onLoadLicenseSummary();
    this.onLoad();
  }

  onLoad() {
    this.planPurchaseService.getUtilizedLincenseDetails(this.b2bId, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onLoadTabs() {
    if (this.tabs.length == 0 && this.localService.languageContent?.plan_purchase) {
      this.tabs = [
        { key: '1', value: this.localService.languageContent.plan_purchase['license_summary'] },
        { key: '2', value: this.localService.languageContent.plan_purchase['issued_license'] }
      ];
      this.selectedTabKey = '1';
    }

    if (this.planTypes.length == 0) {
      const iConfigTypes: GeneralConfigType[] = [GeneralConfigType.PlanType];
      this.configurationManagementService.getConfigurationsToDisplayMulti(iConfigTypes, true, false).subscribe(result => {
        result.forEach(item => {
          switch (parseInt(item.key)) {
            case GeneralConfigType.PlanType: {
              this.planTypes = item.value;
            } break;
          }
        });
      });
    }
  }

  onLoadLicenseSummary() {
    this.planPurchaseService.getB2bLicenseSummary(this.b2bId).subscribe(result => {
      this.b2bLicenseSummary = result;
    });
  }
}
